import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/api/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class ConversorGuard  {
  constructor(private authService: AuthService, private router: Router) {}

  async canActivate() {
    if (await this.authService.IsLoggedIn()) {
      return true;
    } else {
      this.router.navigate(['/ingresar']);
      return false;
    }
  }
}
